import { useState } from 'react';
import { toast, Toaster } from 'react-hot-toast';
import authService from '../services/auth';
import './AdminPanel.css';
import '../styles/api.css';
import '../styles/responsive-admin.css';

// Import layout and components
import ResponsiveLayout from './layout/ResponsiveLayout';
import ResponsiveDashboard from './admin/ResponsiveDashboard';
import ReferralPartners from './admin/ReferralPartners';
import TeamLeads from './admin/TeamLeads';
import Admissions from './admin/Admissions';
import Enquiries from './admin/Enquiries';
import Universities from './admin/Universities';
import UnifiedTestimonials from './admin/UnifiedTestimonials';
import Gallery from './admin/Gallery';
import Blogs from './admin/Blogs';
import News from './admin/News';
import Features from './admin/Features';
import Countries from './admin/Countries';
import Courses from './admin/Courses';
import UniversityCountries from './admin/UniversityCountries';
import SEOManagement from './admin/SEOManagement';
import TaskAllocation from './admin/TaskAllocation';
import InBoundTaskAllocation from './admin/InBoundTaskAllocation';
import ChangePassword from './admin/ChangePassword';
import DocumentsManager from './admin/DocumentsManager';
import AccountsManager from './admin/AccountsManager';

const AdminPanel = () => {
  const [user] = useState(authService.getCurrentUser());
  const [activeSection, setActiveSection] = useState(
    user?.role === 'seo_manager' ? 'seo' : 'dashboard'
  );
  const [selectedCountry, setSelectedCountry] = useState('all');
  const [partnerFilter, setPartnerFilter] = useState(null);

  const renderContent = () => {
    switch (activeSection) {
      case 'dashboard':
        return <ResponsiveDashboard user={user} selectedCountry={selectedCountry} />;
      case 'referral-partners':
        return (
          <ReferralPartners
            user={user}
            selectedCountry={selectedCountry}
            onNavigateToAdmissions={(partnerId, partnerName, options) => {
              if (options?.filterByPartner) {
                setPartnerFilter({ id: partnerId, name: partnerName });
              }
              setActiveSection('admissions');
            }}
          />
        );
      case 'team-leads':
        return <TeamLeads user={user} selectedCountry={selectedCountry} />;
      case 'admissions':
        return (
          <Admissions
            user={user}
            partnerFilter={partnerFilter}
            onClearPartnerFilter={() => setPartnerFilter(null)}
          />
        );
      case 'enquiries':
        return <Enquiries user={user} />;
      case 'universities':
        return <Universities user={user} />;
      case 'countries':
        return <Countries user={user} />;
      case 'courses':
        return <Courses user={user} />;
      case 'university-countries':
        return <UniversityCountries user={user} />;
      case 'testimonials':
        return <UnifiedTestimonials user={user} />;
      case 'seo':
        return <SEOManagement user={user} />;
      case 'gallery':
        return <Gallery user={user} />;
      case 'blogs':
        return <Blogs user={user} />;
      case 'news':
        return <News user={user} />;
      case 'features':
        return <Features user={user} />;
      case 'task-allocation':
        return <TaskAllocation user={user} selectedCountry={selectedCountry} />;
      case 'inbound-task-allocation':
        return <InBoundTaskAllocation user={user} selectedCountry={selectedCountry} />;
      case 'change-password':
        return <ChangePassword user={user} />;
      case 'documents-manager':
        return <DocumentsManager user={user} />;
      case 'accounts-manager':
        return <AccountsManager user={user} />;
      default:
        return <ResponsiveDashboard user={user} selectedCountry={selectedCountry} />;
    }
  };

  return (
    <>
      <Toaster position='top-right' />
      <ResponsiveLayout
        user={user}
        activeSection={activeSection}
        onSectionChange={setActiveSection}
        selectedCountry={selectedCountry}
        onCountryChange={setSelectedCountry}
      >
        {renderContent()}
      </ResponsiveLayout>
    </>
  );
};

export default AdminPanel;
